export default __webpack_public_path__ + "static/bhp-8ab99acd9e314590661f88b7d8772686.jpeg";